import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Index from './pages/index';
import Contact from './pages/contact';
import Nosotros from './pages/page-about';
import AbusoSustancias from './pages/page-abuso-sustancias';
import Ansiedad from './pages/page-ansiedad';
import Depresion from './pages/page-depresion';
import Esquizofrenia from './pages/page-esquizofrenia';
import Estrespostraumatico from './pages/page-estres-post';
import Tdah from './pages/page-tdah';
import Toc from './pages/page-toc';
import Trastornobipolar from './pages/page-tra-bipolar';
import Trastornopanico from './pages/page-tra-panico';
import Trastornosueno from './pages/page-tra-sueño';
import EMT from './pages/page-emt';
import DCS from './pages/page-dcs';
import Rehacom from './pages/page-rehacom';
import { AnimatePresence, motion } from 'framer-motion';


function AnimatedRoutes() {

  const location = useLocation();

  return (
    <AnimatePresence mode='wait'>
    <Routes location={location} key={location.pathname} >
      <Route path='/' element={ <PageWrapper> <Index/></PageWrapper>} />    
      <Route path='/nosotros' element={<PageWrapper> <Nosotros/></PageWrapper>} />     
      <Route path='/contacto' element={ <PageWrapper><Contact/></PageWrapper> } />     
      <Route path='/ansiedad' element={ <PageWrapper><Ansiedad /></PageWrapper>  } /> 
      <Route path='/depresion' element={ <PageWrapper><Depresion /></PageWrapper> } /> 
      <Route path='/tdah' element={<PageWrapper><Tdah /> </PageWrapper> } /> 
      <Route path='/trastornobipolar' element={<PageWrapper><Trastornobipolar /> </PageWrapper> } /> 
      <Route path='/trastornosueno' element={<PageWrapper><Trastornosueno /> </PageWrapper> } /> 
      <Route path='/toc' element={<PageWrapper><Toc /> </PageWrapper> } /> 
      <Route path='/trastornopanico' element={<PageWrapper><Trastornopanico /> </PageWrapper> } /> 
      <Route path='/estrespostraumatico' element={<PageWrapper><Estrespostraumatico /> </PageWrapper> } /> 
      <Route path='/abusodesustancias' element={<PageWrapper><AbusoSustancias /> </PageWrapper> } /> 
      <Route path='/esquizofrenia' element={ <PageWrapper><Esquizofrenia /></PageWrapper> } /> 
      <Route path='/emt' element={<PageWrapper><EMT /> </PageWrapper>} /> 
      <Route path='/dcs' element={<PageWrapper><DCS /> </PageWrapper>} /> 
      <Route path='/rehacom' element={<PageWrapper><Rehacom /> </PageWrapper>} /> 
    </Routes>
    </AnimatePresence>
  );
}

function PageWrapper({ children }){
  return (
    <motion.div
    initial={{ opacity:0.4, y:20}}
    animate={{ opacity:1, y:0}}
    transition={{duration: 0.5, ease:"easeInOut"}}
  
    >
      {children}
    </motion.div>
  )
}

function App(){
  return (
  
     <AnimatedRoutes />
   
  )
}

export default App;
